
const getScrollbarWidth = () => {
    return window.innerWidth - document.documentElement.clientWidth;
};

const getBodyProps = () => {
    return {
        'overflow': 'hidden',
        'padding-right': `${getScrollbarWidth()}px`, 
    };
};

export function lockScroll() {
    Object.assign(document.documentElement.style, getBodyProps());
}

export function unlockScroll() {
    Object.keys(getBodyProps()).forEach(prop => {
        document.documentElement.style.removeProperty(prop);
    });
}
